<template>
    <div>
        <div class="mb-1">
            <div v-if="hasPatientNotification">
                Patient notifié le : {{ hasPatientNotification  | shortDate }}
                <v-icon color="success">done</v-icon>
            </div>
            <div v-else>
                <div v-if="!patient.notification">
                    Les notifications sont désactivées pour ce patient
                </div>
                <div v-else-if="!patient.email">
                    Aucun e-mail saisi pour ce patient
                </div>
                <div v-else>
                    Notification patient prévue le : {{ followUp.notification_patient_date | shortDate }}
                    <v-icon>schedule</v-icon>
                </div>
            </div>
        </div>
        <div class="mb-1">
            <div v-if="hasDoctorNotification">
                Docteur notifié le : {{ hasDoctorNotification  | shortDate }}
                <v-icon color="success">done</v-icon>
            </div>
            <div v-else-if="forDoctor">
                Notification docteur prévue le : {{ followUp.notification_doctor_date | shortDate }}
                <v-icon>schedule</v-icon>
            </div>
        </div>
        <div class="mb-1">
            <div v-if="hasNurseNotification">
                Secretariat notifié le : {{ hasNurseNotification  | shortDate }}
                <v-icon color="success">done</v-icon>
            </div>
            <div v-else-if="forPatient">Notification secretariat prévue le : {{ followUp.notification_nurse_date | shortDate }}
                <v-icon>schedule</v-icon>
            </div>
        </div>
        <div class="mb-1" v-if="manualNotifications.length !==0">
            <span>Patient notifié manuellement le :</span>
            <ul>
                <li v-for="notification in manualNotifications">
                    {{ notification.created_at  | shortDate }}
                    <v-icon color="success">done</v-icon>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "NotificationDate",
    props: {
        followUp: {
            type: Object,
            required: true
        },
        patient: {
            type: Object,
            required: true
        },
        forDoctor: {
            type: Boolean,
            required: true
        },
        forPatient: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        hasPatientNotification() {
            if (this.followUp.follow_up_notifications.some(notification => notification.target === 'patient')) {
                let notification = this.followUp.follow_up_notifications.find(notification => notification.target === 'patient' && notification.type !== 'manual')
                return notification?.created_at
            }
            return false;
        },
        hasDoctorNotification() {
            if (this.followUp.follow_up_notifications.some(notification => notification.target === 'doctor')) {
                let notification = this.followUp.follow_up_notifications.find(notification => notification.target === 'doctor')
                return notification?.created_at
            }
            return false;
        },
        hasNurseNotification() {
            if (this.followUp.follow_up_notifications.some(notification => notification.target === 'nurse')) {
                let notification = this.followUp.follow_up_notifications.find(notification => notification.target === 'nurse')
                return notification?.created_at
            }
            return false;
        },
        manualNotifications() {
            return this.followUp.follow_up_notifications.filter(notification => notification.type === 'manual')
        }
    }

}
</script>
